import mockHelperAttributes from './mock-helper.attributes';

export default (...args: any[]) => mockHelperAttributes('input', 'inputs', ...args);
